<template>
	<div class="play-plan">
		<enfold-uc>
			<template slot="up">
				<div class="titd">
					<span class="tit">{{$t('schedule.playPlan')}}</span>
				</div>
			</template>

			<template slot="center">
				<template v-if="this.$pstore.state.finaldata.length!=0">
					<div class="mid">
						<div class="groups count">
							<div class="left countradio">
								<el-radio v-model="radio" label="count" @change="changeDisable()"><span
										class="conten">{{$t('schedule.playCount')}}</span>
								</el-radio>
							</div>
							<div class="right">
								{{$t('schedule.playsCount')}} <el-select :value="countvalue1"
									v-if="this.$pstore.state.finaldata[this.$pstore.state.currentindex].count!=0"
									:placeholder="$t('schedule.pleaseSelect')" size="medium" class="select"
									:disabled="this.$pstore.state.finaldata[this.$pstore.state.currentindex].radio!='count'"
									@change="savecount" id="count">
									<el-option v-for="item in options1" :key="item.value" :label="$t(item.label)"
										:value="item.value">
									</el-option>
								</el-select>
								<el-input v-model="my_countvalue" size="medium" @blur="save_my_countvalue"
									style="width: 221px;" oninput="value=value.replace(/[^\d]/g,'')"
									v-if="this.$pstore.state.finaldata[this.$pstore.state.currentindex].count==0">
								</el-input>
							</div>
						</div>
						<div class="groups time">
							<div class="left">
								<el-radio v-model="radio" label="time" @change="changeDisable()"><span
										class="conten">{{$t('schedule.playTimes')}}</span>
								</el-radio>
							</div>
							<div class="right">
								{{$t('schedule.conPlayTime')}} <el-select :value="timevalue1" :placeholder="$t('schedule.pleaseSelect')" size="medium"
									v-if="this.$pstore.state.finaldata[this.$pstore.state.currentindex].time!=0"
									class="select times" @change="savetime"
									:disabled="this.$pstore.state.finaldata[this.$pstore.state.currentindex].radio!='time'">
									<el-option v-for="item in options2" :key="item.value" :label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
								<el-time-picker v-model="my_timevalue" size="medium" :picker-options="{
                                                      selectableRange: '00:00:01 - 23:59:59'
                                                          }" @change="save_my_time" value-format="HH:mm:ss"
									v-if="this.$pstore.state.finaldata[this.$pstore.state.currentindex].time==0">

								</el-time-picker>
							</div>
						</div>
					</div>

					<div class="button">
						<div class="control fabu" @click="publish()">{{$t('schedule.publish')}}</div>
						<!-- <div class="control white">保存</div> -->
						<div class="control white" @click="cancel">{{$t('terminal.cancel')}}</div>
					</div>

				</template>
			</template>
		</enfold-uc>
		<!-- <get-device-dialog :deviceDialogVisible="deviceDialogVisible" @changeShow="showAdd" :play_mode="1">
		</get-device-dialog> -->
		<terminal-list :terminalListDV="deviceDialogVisible" @publishTerminal="publishTerminal" :diffIsAppend="1"></terminal-list>
	</div>
</template>
<!-- 循环播放 -->
<script>
	//import GetDeviceDialog from './GetDeviceDialog.vue'
	import EnfoldUc from "@/components/basics/EnfoldUC"
	import TerminalList from '@/components/schedule/windows/children/TerminalList'
	import {
		mPagination
	} from "@/components/basics/mixins";
	import {groupByTerminal} from "@/assets/scripts/publicFunction.js";
	export default {
		name: 'PlayPlan',
		mixins: [mPagination],
		components: {
			//GetDeviceDialog,
			EnfoldUc,
			TerminalList
		},
		data() {
			return {
				deviceDialogVisible: false,
				isDisabled: false,
				//radio: 'count',
				options1: [
					{
						value: '0',
						label: 'schedule.customize'
					},{
						value: '1',
						label: 'schedule.once'
					}, {
						value: '2',
						label: 'schedule.twice'
					}, {
						value: '3',
						label: 'schedule.treeTimes'
					}, {
						value: '4',
						label: 'schedule.fourTimes'
					}, {
						value: '5',
						label: 'schedule.fiveTimes'
					}, {
						value: '6',
						label: 'schedule.sixTimes'
					}, {
						value: '7',
						label: 'schedule.sevenTimes'
					}, {
						value: '8',
						label: 'schedule.eightTimes'
					}, {
						value: '9',
						label: 'schedule.nineTimes'
					}, {
						value: '10',
						label: 'schedule.tenTimes'
					}
				],
				countvalue: this.countvalue1,
				options2: [{
						value: '0',
						label: this.$t('schedule.customize')
					},
					{
						value: '1',
						label: '1:00:00'
					}, {
						value: '2',
						label: '2:00:00'
					}, {
						value: '3',
						label: '3:00:00'
					}, {
						value: '4',
						label: '4:00:00'
					}, {
						value: '5',
						label: '5:00:00'
					}, {
						value: '6',
						label: '6:00:00'
					}, {
						value: '7',
						label: '7:00:00'
					}, {
						value: '8',
						label: '8:00:00'
					}, {
						value: '9',
						label: '9:00:00'
					}, {
						value: '10',
						label: '10:00:00'
					}, {
						value: '11',
						label: '11:00:00'
					}, {
						value: '12',
						label: '12:00:00'
					}
				],
				timevalue: this.timevalue1
			}
		},
		methods: {
			showAdd(data) {
				if (data === 'false') {
					this.deviceDialogVisible = false
				} else {
					this.deviceDialogVisible = true
				}
			},
			changeDisable() {
				this.isDisabled = !this.isDisabled
			},
			//点击保存确定保存播放次数和时间到vuex中
			savecount(v) {
				console.log("save")
				this.$pstore.commit('savecount', v);
			},
			save_my_countvalue() {
				console.log(this.my_countvalue);
				if(this.my_countvalue<1){
					this.$msg({
						type:'warning',
						message:this.$t('schedule.countTips')
					});
					this.my_countvalue = 1;
				}else{
					this.$pstore.commit('save_my_countvalue', this.my_countvalue);
				}
				
			},
			save_my_time() {
				this.$pstore.commit('save_my_time', this.my_timevalue);
			},
			savetime(v) {
				this.$pstore.commit('savetime', v);
			},
			publishTerminal(terminalList, adapter_screen, isAppend){
				if(terminalList && terminalList.length>0){


					
					const group_id = this.$cookies.get("group_id");
        this.$pstore.commit('publish', [terminalList, adapter_screen, isAppend, 1, group_id]);

        let listGroup = groupByTerminal(terminalList, "main_device").map((group) => {
          const { list, main_device } = group;
          return { main_device, ids: list.map((d) => d.id) };
        });

        const { group_id: p_group_id, play_ids, play_mode, publish_strategy, publish_type, isAppend: p_isAppend, adapter_screen: p_adapter_screen, playSchedule } = this.$pstore.state.publishData

        this.$http.post("/admin/publish/addNew", {
          group_id: p_group_id,
          play_ids: play_ids,
          list_group: encodeURIComponent(JSON.stringify(listGroup)),
          play_mode: play_mode,
          publish_strategy: publish_strategy,
          publish_type: publish_type,
          isAppend: p_isAppend,
          adapter_screen: p_adapter_screen,usePlayTimeList: this.$pstore.state.publishData.usePlayTimeList,playTimeList: this.$pstore.state.publishData.playTimeList,playCountList: this.$pstore.state.publishData.playCountList,
          playSchedule: encodeURIComponent(JSON.stringify(playSchedule)),
          is_drafts: 0
        }, () => {
          this.$http.post("/admin/Command/getDownloadList", {}, (res) => {
            this.$store.commit("ISSUE_LIST", res);
          });
        });

        this.$msg({ message: this.$t('cscpp1'), type: 'success', });
        this.$router.push({ name: 'IssueManage' });

					// let ids = [];
					// terminalList.forEach((ele)=>{
					// 	ids.push(ele.id)
					// })
					// let listGroup = groupByTerminal(terminalList, "main_device")
					// this.$pstore.commit('publish', [terminalList, adapter_screen, isAppend, 1, this.groupId]);
					// listGroup.forEach(ele=>{
					// 	let idList = [];
					// 	ele.list.forEach(val=>{
					// 		idList.push(val.id)
					// 	})
					// 	this.$http.post("/admin/publish/add", {
					// 		group_id: this.groupId,
					// 		play_ids: this.$pstore.state.publishData.play_ids,
					// 		device_ids: idList.toString(),
					// 		main_device:ele.main_device,
					// 		play_mode: this.$pstore.state.publishData.play_mode,
					// 		publish_strategy: this.$pstore.state.publishData.publish_strategy,
					// 		publish_type: 0,
					// 		isAppend: isAppend,
					// 		adapter_screen: adapter_screen,
					// 		usePlayTimeList: this.$pstore.state.publishData.usePlayTimeList,
					// 		playTimeList: this.$pstore.state.publishData.playTimeList,
					// 		playCountList: this.$pstore.state.publishData.playCountList,
					// 		is_drafts: 0
					// 	}, data => {
					// 		console.log(data)
					// 		this.$http.post("/admin/Command/getDownloadList", {}, data => {
					// 			this.$store.commit("ISSUE_LIST", data);
					// 		});
					// 		this.$msg({
					// 			message: this.$t('schedule.pubSuccessTip'),
					// 			type: 'success',
					// 		});
					// 		this.$router.push({
					// 			name: 'IssueManage'
					// 		})
					// 	})
					// })
					
					//console.log('terminalList',terminalList);
					//console.log('adapter_screen',adapter_screen);
					//console.log('isAppend',isAppend);
				}
				
				
				this.deviceDialogVisible = false;
			},
			publish() {
				if (this.$pstore.state.finaldata.length <= 1) {
					this.$msg({
						message: this.$t('schedule.selectTip1'),
						type: 'warning'
					});
				} else {
					console.log("dwqdwqd")
					this.deviceDialogVisible = true;
				}

			},
			cancel() {
				this.$router.push({
					path: 'IssueManage'
				})
				//this.$pstore.commit('clearitems')
			}
		},
		computed: {
			countvalue1() {
				return this.$pstore.state.finaldata[this.$pstore.state.currentindex].count
			},
			timevalue1() {
				return this.$pstore.state.finaldata[this.$pstore.state.currentindex].time
			},
			radio: {
				get() {
					return this.$pstore.state.finaldata[this.$pstore.state.currentindex].radio
				},
				set(v) {
					this.$pstore.state.finaldata[this.$pstore.state.currentindex].radio = v
				}
			},
			my_countvalue: {
				get() {
					return this.$pstore.state.finaldata[this.$pstore.state.currentindex].my_countvalue
				},
				set(v) {
					this.$pstore.state.finaldata[this.$pstore.state.currentindex].my_countvalue = v;
				}
			},
			my_timevalue: {
				get() {
					return this.$pstore.state.finaldata[this.$pstore.state.currentindex].my_timevalue
				},
				set(v) {
					this.$pstore.state.finaldata[this.$pstore.state.currentindex].my_timevalue = v;
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	/deep/ .el-radio__inner {
		background: white;
		border-color: #d0d6d9;
	}

	/deep/ .el-radio__input.is-checked .el-radio__inner {
		background: white !important;
		border-color: #35cafa !important;
	}

	/deep/ .el-radio__inner::after {
		width: 9px;
		height: 9px;
		background-color: #35cafa;
		border-radius: 50%;
	}

	.groups /deep/ .el-input__inner {
		border-radius: 40px;
	}
	.groups /deep/ .el-input--suffix{
		border-radius: 40px;
	}
	.select {
		vertical-align: middle;
	}

	.titd {
		height: 100%;
		width: 100%;
	}

	.titd::before {
		display: inline-block;
		content: "";
		height: 100%;
		vertical-align: middle;
	}

	.tit {
		font-family: PingFang-SC-Regular;
		font-size: 16px;
		font-weight: normal;
		font-stretch: normal;
		line-height: 3px;
		height: 16px;
		letter-spacing: 3px;
		color: #617883;
		padding-left: 2%;
	}

	.play-plan {
		/* height: 90vh; */
		height: 100%;
		width: 100%;
		position: relative;
		background-color: white;
	}

	.conten {
		font-family: PingFang-SC-Regular;
		font-size: 16px;
		font-weight: normal;
		font-stretch: normal;
		line-height: 3px;
		letter-spacing: 3px;
		color: #617883;
		flex-direction: column;
	}

	.mid {
		/* border: 1px solid black; */
		display: flex;
		width: 100%;
		height: 20%;
		min-height: 120px;
		margin-top: 1%;
		font-family: PingFang-SC-Regular;
		font-size: 16px;
		font-weight: normal;
		font-stretch: normal;
		line-height: 3px;
		letter-spacing: 3px;
		color: #617883;
		flex-direction: column;
	}

	.control:hover {
		cursor: pointer;
	}

	.count {
		height: 10%;
	}

	.time {
		height: 10%;
	}

	.groups {
		/* border: 1px solid gold; */
		flex-basis: 50%;
		display: flex;
		align-items: center;
		padding-left: 5%;
	}

	.right {
		padding-left: 5%;
	}

	.button {
		position: absolute;
		left: 50%;
		bottom: 4%;
		transform: translate(-50%);
		width: 44%;
		min-width: 380px;
		height: 6%;
		min-height: 35px;
		display: flex;
		justify-content: space-between;
	}

	.control {
		width: 40%;
		text-align: center;
		align-items: center;
		border-radius: 40px;
	}

	.control::before {
		display: inline-block;
		content: "";
		height: 100%;
		vertical-align: middle;
	}

	.fabu {
		background-image: linear-gradient(270deg,
				#86eae7 0%,
				#4cccf0 45%,
				#11adf8 100%),
			linear-gradient(#dddddd,
				#dddddd);
		background-blend-mode: normal,
			normal;
		border-radius: 40px;
		font-family: PingFang-SC-Regular;
		font-size: 24px;
		font-stretch: normal;
		line-height: 38px;
		letter-spacing: 0px;
		color: #ffffff;
	}

	.white {
		border-radius: 40px;
		border-style: solid;
		font-size: 26px;
		border-width: 1px;
		font-family: PingFang-SC-Regular;
		border-image-slice: 1;
		color: #2fb3ff;

	}

	/deep/ .el-input--suffix {
		border-radius: 40px;
	}

	/* 	.radiogroup {
		width: 20%;
		float: left;
		margin-top: 10%;
		margin-left: 10%;
	}

	.radio {
		padding: 17%;
	}

	.selectgroup {
		float: left;
		margin-top: 11%;
		margin-left: 10%;
	}

	.select {
		padding: 5%;
	}

	.selectfloat {
		height: 50%;
		float: left;
	}

	.tips {
		padding-top: 5%;
	}

	.times {
		padding-top: 10%;
	}
	.button{
		float: right;
		padding-top: 50%;
	} */
</style>
